import axios from "axios";

export default {
    namespaced: true,

    state: () => ({
        adminQuotas: []
    }),

    mutations: {
        setAdminQuotas(state, payload) {
            state.adminQuotas = payload;
        },
        clearAdminQuotas(state) {
            state.adminQuotas = [];
        }
    },

    actions: {
        async setUsersAsAdmins({ commit }, data) {
            await axios.post(`/hr_admin/set`, data);
        },

        async getAdminQuotas({ commit }, data) {
            await axios.get(`/hr_admin/${data.id}/limits`).then(({data}) => {
                commit('setAdminQuotas', data)
            })
        },
    }
}
